<template>
  <div class="clm-form__top">
    <div class="clm-form-title">
      <slot></slot>
    </div>
    <div class="clm-form__avatar">
      <img src="/local/img/form/default-avatar.svg" alt="">
    </div>
  </div>

</template>

<script>
export default {
  name: "a-header"
}
</script>